@if (filter() != null) {
  @switch (filter()?.type) {
    @case ('range') {
      <cbre-range class="full" [form]="form()" [filter]="filter()" [showLabel]="showLabel()"></cbre-range>
    }
    <!-- NOTE: TO BE IMPLEMENTED
    @case ('period') {
      <miq-period-item class="full" [form]="form()" [filter]="filter()" [aggregation]="aggregation"></miq-period-item>
    }
    -->
    @case ('multi') {
      <cbre-multi-select
        class="full"
        [form]="form()"
        [filter]="filter()"
        [aggregations]="aggregations()"
        [showLabel]="showLabel()"
      ></cbre-multi-select>
    }
    @default {
      <cbre-equal-filter
        [form]="form()"
        [filter]="filter()"
        [aggregations]="aggregations()"
        [showLabel]="showLabel()"
      ></cbre-equal-filter>
    }
  }
  @if (canRemoveFilter()) {
    <mat-icon (click)="removeFilter.emit(filter())">close</mat-icon>
  }
} @else {
  Missing Filter Configuration
}
